import React from "react";
import Introduction from "../Aboutus/Introduction";
import HeroAboutus from "../Aboutus/HeroAboutus";
import Contactus from "./../Summidence/Contantus";

const Aboutus = () => {
  return (
    <div>
      <HeroAboutus />
      <Introduction />
      {/* <Contactus /> */}
    </div>
  );
};

export default Aboutus;
